import { render } from "./StaticDiagramWraper.vue?vue&type=template&id=c86b7a74"
import script from "./StaticDiagramWraper.vue?vue&type=script&lang=js"
export * from "./StaticDiagramWraper.vue?vue&type=script&lang=js"

import "./StaticDiagramWraper.vue?vue&type=style&index=0&id=c86b7a74&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__